const Cities = ["Chicago"]

export default Cities;